import styled from 'styled-components'
import { BLACK, GRAYSCALE_500, NEUTRAL_100, PALE_BLUE, PALE_PURPLE } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  background-color: ${PALE_BLUE};
  border: 1px solid ${PALE_PURPLE};
  border-radius: 8px;
  padding: 32px 18px;
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 100%;
  width: 32px;
  height: 32px;
`

export const CryptoIcon = styled.img`
  width: 24px;
  height: 24px;
`

export const AmountContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const AmountText = styled.span`
  font-family: ${INTER.bold};
  font-size: 26px;
  color: ${BLACK};
`

export const TickerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const TickerText = styled.span`
  font-family: ${INTER.regular};
  font-size: 13px;
  color: ${GRAYSCALE_500};
`
